import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import FontAwesome from "react-fontawesome";
import {
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Collapse,
  Alert,
  Button as ButtonBootstrap,
  InputGroup,
  InputGroupAddon
} from "reactstrap";
import {
  Link
  // Redirect
} from "react-router-dom";
import styled from "styled-components";
import { KickAvenueBrandIcon } from "../PageApp/NavbarDesktopV3/styled";
import classNames from "classnames";
import { GoogleLogin } from "react-google-login";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";

import Google from "../../images/google.png";
import IconClose from "../../images/cross.png";
import eyeOpen from "../../images/eye-open.png";
import eyeClose from "../../images/eye-close.png";

import { isEmail, isValidPassword } from "../../helpers/regex";
import { Clipboard } from "../../helpers/clipboard";
import {
  Login as LoginForm,
  Register as RegisterForm,
  FormFeedback,
  Button as ButtonSubmit
} from "../Forms";
import { InputSelect } from "../Forms/Input";
import { doSignIn, doSignUp, doSocialSignIn, doFetchProfile } from "../../actions/authAction";
import {
  doClearResetPassword,
  doRequestResetPassword
} from "../../actions/resetPasswordAction";
import {
  doFetchCountries,
  doFetchProvinces
} from "../../actions/postalCodeAction";
import { connect } from "react-redux";

import {
  REDIRECT_FB_MOBILE,
  API_BASE_URL,
  IS_FROM_WEB_APPS
} from "../../constants";
import Analytics from "../../services/Analytics";
const myClipboard = new Clipboard(window, document, navigator);

class ModalLoginNew extends Component {
  constructor(props) {
    super(props);
    const queries = this.props.location
      ? new URLSearchParams(this.props.location.search)
      : "";
    this.state = {
      sections: "LOGIN",
      LOGIN: {
        email: "",
        password: "",
        _error: null
      },
      SIGNUP: {
        email: "",
        password: "",
        confirm_password: "",
        _error: null
      },
      FORGET_PASSWORD: {
        email: "",
        _error: null
      },
      _submitSignin: false,
      _submitSocial: false,
      _submitForgetPassword: false,

      _shouldRedirect: false,
      _redirectTo:
        this.props.location && this.props.location.search
          ? queries.get("next")
          : "/",
      onCopyMode: false,
      copyActionMessage: "",
      url:
        window.location.origin ||
        window.location.protocol +
        "//" +
        window.location.hostname +
        (window.location.port ? ":" + window.location.port : ""),
      visiblePassword: false,
      visibleConfirmPassword: false,
      countryList: [{ value: "", label: "Country" }],
      provinceList: [{ value: "", label: "Province" }],
      countrySelected: null,
      provinceSelected: null
    };
    this.onChange = this.onChange.bind(this);
    this.onLogin = this.onLogin.bind(this);
    this.onSignUp = this.onSignUp.bind(this);
    this.onForgetPassword = this.onForgetPassword.bind(this);
    this.submitForget = this.submitForget.bind(this);
    this.toggleVisible = this.toggleVisible.bind(this);
  }

  componentDidMount() {
    if (this.props.isLogged === true) {
      this.setState({ _shouldRedirect: this.props.isLogged });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { dataSignIn, dataAuth, redirectTo } = this.props;

    if (
      !dataSignIn.isSubmit &&
      prevProps.dataSignIn.isSubmit !== dataSignIn.isSubmit
    ) {
      if (dataSignIn.error) {
        if (dataSignIn.error.status_code === 401) {
          this.setState(prevState => {
            return {
              LOGIN: {
                ...prevState.LOGIN,
                _error: {
                  errors: { password: ["Incorrect password."] },
                  status_code: 422
                }
              },
              _submitSignin: false
            };
          });
        } else {
          this.setState(prevState => {
            return {
              LOGIN: {
                ...prevState.LOGIN,
                _error: {
                  ...dataSignIn.error
                }
              },
              _submitSignin: false
            };
          });
        }
      } else {
        this.setState({
          _shouldRedirect: dataAuth.shouldRedirect,
          _submitSignin: false
        });

        this.props.onClosed();

        if (redirectTo) {
          this.props.history.push(redirectTo);
        }
      }
    }

    if (prevState.sections !== this.state.sections) {
      if (this.state.sections === "SIGNUP") {
        this.props.getCountries();
      }
    }

    if (prevProps.dataCountries.isFetch !== this.props.dataCountries.isFetch) {
      const { error, data } = this.props.dataCountries;

      if (!error) {
        const countries = data.map(item => ({
          value: item.code3,
          label: item.name
        }));

        this.setState({
          countryList: [{ value: "", label: "Country" }, ...countries]
        });
      }
    }

    if (prevProps.dataProvinces.isFetch !== this.props.dataProvinces.isFetch) {
      const { error, data } = this.props.dataProvinces;

      if (!error) {
        const provinces = data.map((item, index) => ({
          value: item.id,
          label: item.name
        }));

        this.setState({
          provinceList: [{ value: "", label: "Province" }, ...provinces]
        });
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.isOpen != nextProps.isOpen && nextProps.isOpen === false) {
      this._setInitialSet();
    }

    this._handlerSignUpError(nextProps);
  }

  _setInitialSet = () => {
    this.setState({
      sections: "LOGIN",
      LOGIN: {
        email: "",
        password: "",
        _error: null
      },
      SIGNUP: {
        email: "",
        password: "",
        confirm_password: "",
        _error: null
      },
      FORGET_PASSWORD: {
        email: "",
        _error: null
      },
      _submitSignin: false,
      _submitSocial: false,
      _submitForgetPassword: false,

      onCopyMode: false,
      copyActionMessage: ""
    });
    this.props.doClearResetPassword();
  };

  _handlerSignUpError = nextProps => {
    if (
      nextProps.dataSignUp.isSubmit === false &&
      nextProps.dataSignUp.isSubmit !== this.props.dataSignUp.isSubmit &&
      this.state._submitSignUp === true
    ) {
      if (nextProps.dataSignUp.error) {
        this.setState(prevState => {
          return {
            SIGNUP: {
              ...prevState.SIGNUP,
              _error: {
                ...nextProps.dataSignUp.error
              }
            },
            _submitSignUp: false
          };
        });
      } else {
        this.props.onClosed();
        this.setState({
          _shouldRedirect: nextProps.dataAuth.shouldRedirect,
          _submitSignUp: false
        });
      }
    }
  };

  handleSelectCountryChange = selected => {
    if (selected) {
      this.setState(
        {
          countrySelected: selected,
          provinceSelected: null
        },
        () => {
          this.props.getProvinces(selected.value);
        }
      );
    }
  };

  handleSelectProvinceChange = selected => {
    if (selected) {
      this.setState({
        provinceSelected: selected
      });
    }
  };

  _renderSocmedLogin = () => {
    let { onCopyMode } = this.state;
    let isFromAppBrowser = this.isFromWebApps();

    return !isFromAppBrowser
      ? this._renderSocmedButtonBrowser()
      : onCopyMode
        ? this._renderOnCopyMode()
        : this._renderSocmedButtonInApp();
  };

  _renderSocmedButtonBrowser = () => {
    return (
      <Row className="auth-social">
        <Col
          xs={12}
          sm={12}
          md={12}
          lg={5}
          className={classNames("col-auth-fb", {
            disabled: this.state._submitSocial || this.state._submitSignin
          })}
        >
          <FacebookLogin
            appId="1588115344582034"
            fields="name,email,verified"
            version="2.12"
            disableMobileRedirect={true}
            scope="public_profile,email"
            onFailure={this._failureFacebook}
            callback={this._responseFacebook}
            isDisabled={this.state._submitSocial || this.state._submitSignin}
            render={props => (
              <div className="auth-facebook" onClick={props.onClick}>
                <FontAwesome
                  name="facebook"
                  style={{
                    fontSize: "1rem",
                    color: "#ffffff",
                    marginRight: "10px"
                  }}
                />
                <span className="text-auth-facebook">
                  Masuk Dengan Facebook
                </span>
              </div>
            )}
          />
        </Col>
        <Col
          xs={12}
          sm={12}
          mg={12}
          lg={2}
          style={{ textAlign: "center" }}
          className="col-or"
        >
          <span>OR</span>
        </Col>
        <Col xs={12} sm={12} md={12} lg={5} className="col-auth-google">
          <GoogleLogin
            clientId="594858415021-kion5vibkgo9kf91toajjcb6h7ltt4aq.apps.googleusercontent.com"
            onSuccess={this._responseGoogle}
            onFailure={this._responseGoogle}
            className="auth-google"
            disabled={this.state._submitSocial || this.state._submitSignin}
            disabledStyle={{ opacity: 0.65 }}
          >
            <KickImage src={Google} alt="Google" />
            <span className="text-auth-google">Masuk Dengan Google</span>
          </GoogleLogin>
        </Col>
      </Row>
    );
  };

  _renderSocmedButtonInApp = () => {
    return (
      <Row className="auth-social">
        <Col
          xs={12}
          sm={12}
          md={12}
          lg={5}
          className={classNames("col-auth-fb", {
            disabled: this.state._submitSocial || this.state._submitSignin
          })}
        >
          <div className="auth-facebook" onClick={this.onCopyMode}>
            <FontAwesome
              name="facebook"
              style={{ color: "#ffffff", marginRight: "10px" }}
            />
            <span className="text-auth-facebook">Masuk Dengan Facebook</span>
          </div>
        </Col>

        <Col
          xs={12}
          sm={12}
          md={12}
          lg={2}
          style={{ textAlign: "center" }}
          className="col-or"
        >
          <span>OR</span>
        </Col>

        <Col xs={12} sm={12} md={12} lg={5} className="col-auth-google">
          <div className="auth-facebook" onClick={this.onCopyMode}>
            <FontAwesome
              name="google"
              style={{ fontSize: "1rem", color: "blue", marginRight: "10px" }}
            />
            <span className="text-auth-google">Masuk Dengan Google</span>
          </div>
        </Col>
      </Row>
    );
  };

  _renderOnCopyMode = () => {
    let { copyActionMessage } = this.state;
    return (
      <Row>
        <Col>
          <Card>
            <p
              className="text-right"
              style={{ margin: "10px", marginBottom: "0" }}
            >
              <KickImage
                id="icon-home"
                src={IconClose}
                style={{ width: "30px" }}
                onClick={this.closeCopyMode}
                alt="Home"
              />
            </p>
            <CardBody>
              <Alert color="warning">
                Maaf, in-app browser tidak mendukung login dengan sosial media.
                Silahkan tekan tombol "Copy Text", tutup app ini dan paste kan
                di browser kesukaan <strong>anda</strong>.
              </Alert>
              <Input
                type="textarea"
                name="text"
                id="urlLink"
                style={{ marginBottom: "15px" }}
                value={`${this.state.url}/login?next=/promo/reactxdisruptor`}
              />
              {!!copyActionMessage && (
                <Alert color="success">{copyActionMessage}</Alert>
              )}
              <ButtonBootstrap onClick={this.copyToClipBoard}>
                Copy Text
              </ButtonBootstrap>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  };

  copyToClipBoard = () => {
    let input = document.getElementById("urlLink"),
      val = input.value;

    if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
      myClipboard.copy(val);
    } else {
      input.select();
      document.execCommand("copy");
    }
    this.setState({
      copyActionMessage:
        "Text Copied! Silahkan paste di browser chrome/browser kesukaan di hp anda"
    });
  };

  onCopyMode = () => {
    this.setState({
      onCopyMode: true
    });
  };

  closeCopyMode = () => {
    this.setState({
      onCopyMode: false
    });
  };

  _validateForm() {
    let { sections } = this.state;
    let errors = {};
    //console.log("this.state[ " + sections + "]: ", this.state[sections])
    if (this.state[sections].email === "")
      errors["email"] =
        errors["email"] !== undefined
          ? [...errors.email, "Input your email."]
          : ["Input your email."];

    if (!isEmail(this.state[sections].email))
      errors["email"] =
        errors["email"] !== undefined
          ? [...errors.email, "Incorrect email."]
          : ["Incorrect email."];

    if (sections !== "FORGET_PASSWORD") {
      if (this.state[sections].password === "")
        errors["password"] =
          errors["password"] !== undefined
            ? [...errors.password, "Input your password."]
            : ["Input your password."];
    }

    if (sections === "SIGNUP") {
      if (!isValidPassword(this.state["SIGNUP"].password))
        errors["password"] =
          errors["password"] !== undefined
            ? [
              ...errors.password,
              "Your password at least contain 8 characters include (. ! -) and combine with capital letter or numeric."
            ]
            : [
              "Your password at least contain 8 characters include (. ! -) and combine with capital letter or numeric."
            ];
      if (this.state["SIGNUP"].confirm_password === "")
        errors["confirm_password"] =
          errors["confirm_password"] !== undefined
            ? [...errors.confirm_password, "Input your confirm password."]
            : ["Input your confirm password."];
      if (
        this.state["SIGNUP"].confirm_password !== this.state["SIGNUP"].password
      )
        errors["confirm_password"] =
          errors["confirm_password"] !== undefined
            ? [
              ...errors.confirm_password,
              "Confirm password not same with your password."
            ]
            : ["Confirm password not same with your password."];
    }

    if (Object.keys(errors).length) {
      this.setState(prevState => {
        return {
          [sections]: {
            ...prevState[sections],
            _error: {
              errors: { ...errors },
              status_code: 422,
              message: "Incorrect login, please check and try again."
            }
          }
        };
      });
    }
    return errors;
  }

  _responseGoogle = googleUser => {
    if (!googleUser.hasOwnProperty("error")) {
      const { tokenId, profileObj } = googleUser;
      const dataUser = {
        id: profileObj.googleId,
        email: profileObj.email,
        typed_email: profileObj.email,
        oauth_token: tokenId,
        type: "google",
        name: profileObj.name
      };
      this.setState(
        {
          _submitSignin: true,
          _submitSignUp: true,
          _submitSocial: true
        },
        () => {
          this.props.doSocialSignIn(dataUser);
        }
      );
    }

    return null;
  };

  _responseFacebook = facebookUser => {
    if (!facebookUser.hasOwnProperty("status")) {
      const dataUser = {
        id: facebookUser.id,
        email: facebookUser.email,
        typed_email: facebookUser.email,
        type: "facebook",
        oauth_token: facebookUser.accessToken,
        name: facebookUser.name
      };
      this.setState(
        {
          _submitSignin: true,
          _submitSignUp: true,
          _submitSocial: true
        },
        () => {
          this.props.doSocialSignIn(dataUser);
        }
      );
    }

    return null;
  };

  _failureFacebook = facebookUser => {
    return null;
  };

  _renderError() {
    let { sections } = this.state;
    const { _error } = this.state[sections];
    if (_error !== null) {
      switch (_error.status_code) {
        case 422:
          return (
            <Alert color="danger">
              Incorrect login, please check and try again.
            </Alert>
          );
        default:
          return (
            <Alert color="danger">
              We got something error. Please inform our Admin through live chat.
            </Alert>
          );
      }
    }
    return null;
  }

  _hasError(name) {
    let { sections } = this.state;
    if (
      this.state[sections]._error !== null &&
      this.state[sections]._error.status_code === 422
    ) {
      return (
        Object.keys(this.state[sections]._error.errors).filter(
          err => err === name
        ).length > 0
      );
    }
    return false;
  }

  onChange = e => {
    let { sections } = this.state;
    this.setState({
      [sections]: {
        ...this.state[sections],
        [e.target.name]: e.target.value,
        _error: null
      }
    });
  };

  _changeSection(name) {
    this.setState({ sections: name });
  }

  _toggle = () => {
    if (!this.props.dataSignIn.isSubmit && !this.props.dataSignUp.isSubmit) {
      this.props.onClosed();
    }
  };

  toggleVisible(visibleType) {
    if (visibleType === "password") {
      this.setState({
        visiblePassword: !this.state.visiblePassword
      });
    } else {
      this.setState({
        visibleConfirmPassword: !this.state.visibleConfirmPassword
      });
    }
  }

  _renderSocmedButton = () => {
    return (
      <div>
        <Col
          xs={6}
          sm={6}
          md={6}
          lg={6}
          className={classNames("col-auth-fb", {
            disabled: this.state._submitSocial || this.state._submitSignin
          })}
        >
          <FacebookLogin
            appId="1588115344582034"
            fields="name,email,verified"
            version="2.12"
            disableMobileRedirect={true}
            scope="public_profile,email"
            onFailure={this._failureFacebook}
            callback={this._responseFacebook}
            isDisabled={this.state._submitSocial || this.state._submitSignin}
            render={props => (
              <div className="auth-facebook" onClick={props.onClick}>
                <span className="text-auth-facebook">
                  Masuk Dengan Facebook
                </span>
              </div>
            )}
          />
        </Col>
        <Col xs={6} sm={6} md={6} lg={6} className="col-auth-google">
          <GoogleLogin
            clientId="594858415021-kion5vibkgo9kf91toajjcb6h7ltt4aq.apps.googleusercontent.com"
            onSuccess={this._responseGoogle}
            onFailure={this._responseGoogle}
            className="auth-google"
            disabled={this.state._submitSocial || this.state._submitSignin}
            disabledStyle={{ opacity: 0.65 }}
          >
            <KickImage src={Google} alt="Google" />
            <span className="text-auth-google">Masuk Dengan Google</span>
          </GoogleLogin>
        </Col>
      </div>
    );
  };

  _renderLogin = () => {
    let { visiblePassword } = this.state;
    return (
      <Row>
        <Col>
          <Form onSubmit={this.onLogin}>
            <FormGroup>
              <Label for="email">Email</Label>
              <Input
                autoComplete="off"
                type="email"
                name="email"
                id="email"
                onChange={this.onChange}
              />
              <div style={{ height: "20px" }}>
                <TextError>
                  {this.state["LOGIN"]._error !== null
                    ? this.state["LOGIN"]._error.errors.email !== undefined
                      ? this.state["LOGIN"]._error.errors.email[0]
                      : null
                    : null}
                </TextError>
              </div>
            </FormGroup>

            <FormGroup>
              <Label for="password">Password</Label>
              <div style={{ position: "absolute", width: "92%" }}>
                <Input
                  type={visiblePassword ? "text" : "password"}
                  name="password"
                  id="password"
                  onChange={this.onChange}
                />

                <KickImage
                  // className={classNames("img-eye", {
                  //   "with-error": this.state["LOGIN"]._error !== null
                  // })}
                  className="img-eye"
                  src={visiblePassword ? eyeOpen : eyeClose}
                  onClick={() => this.toggleVisible("password")}
                  alt="visible-password"
                />
                <div style={{ height: "20px" }}>
                  <TextError>
                    {this.state["LOGIN"]._error !== null
                      ? this.state["LOGIN"]._error.errors.password !== undefined
                        ? this.state["LOGIN"]._error.errors.password[0]
                        : null
                      : null}
                  </TextError>
                </div>
              </div>
            </FormGroup>
            <p className="text-right" style={{ marginTop: "60px" }}>
              <span
                onClick={() => this._toggleLogin("FORGET_PASSWORD")}
                className="text-black green-link d-inline-block cursor-pointer"
              >
                Forgot Password ?
              </span>
            </p>
            <div className="bottom-link">
              <p>Have not been registered yet?</p>
              You can{" "}
              <span
                className="text-black green-link d-inline-block cursor-pointer"
                onClick={() => this._toggleLogin("SIGNUP")}
              >
                click here to <b>REGISTER</b>
              </span>
            </div>

            <ButtonSubmit
              size="lg"
              className="btn-green bold mt20"
              buttonText="Login"
              disabled={this.state._submitSignin === true}
              block
              social={this.state._submitSocial}
            />
          </Form>
        </Col>
      </Row>
    );
  };

  eyeClassName = () => {
    if (this.state["SIGNUP"]._error !== null) {
      if (
        this.state["SIGNUP"]._error.errors.email !== undefined &&
        this.state["SIGNUP"]._error.errors.password !== undefined &&
        this.state["SIGNUP"]._error.errors.confirm_password !== undefined
      ) {
        if (
          this.state["SIGNUP"]._error.errors.password[0].includes(
            "8 characters"
          )
        ) {
          return "pwd-char";
        } else {
          return "with-error-regist";
        }
      } else if (this.state["SIGNUP"]._error.errors.email !== undefined) {
        return "only-mail";
      } else if (this.state["SIGNUP"]._error.errors.password !== undefined) {
        if (
          this.state["SIGNUP"]._error.errors.password[0].includes(
            "8 characters"
          )
        ) {
          return "pwd-char";
        } else {
          return "with-error-regist";
        }
      } else if (
        this.state["SIGNUP"]._error.errors.confirm_password !== undefined
      ) {
        return "only-confirm";
      }
    }
  };

  _renderSignUp = () => {
    const { visiblePassword, visibleConfirmPassword } = this.state;

    return (
      <Row>
        <Col>
          <Form onSubmit={this.onSignUp}>
            <FormGroup>
              <Label for="email">Email</Label>
              <Input
                autoComplete="off"
                type="email"
                name="email"
                id="email"
                onChange={this.onChange}
              />
              <div style={{ height: "20px" }}>
                <TextError>
                  {this.state["SIGNUP"]._error !== null
                    ? this.state["SIGNUP"]._error.errors.email !== undefined
                      ? this.state["SIGNUP"]._error.errors.email[0]
                      : null
                    : null}
                </TextError>
              </div>
            </FormGroup>

            <FormGroup>
              <Label for="password">Password</Label>
              <div style={{ position: "absolute", width: "92%" }}>
                <Input
                  type={visiblePassword ? "text" : "password"}
                  name="password"
                  id="password"
                  onChange={this.onChange}
                />
                <KickImage
                  className={classNames("img-eye password")}
                  src={visiblePassword ? eyeOpen : eyeClose}
                  onClick={() => this.toggleVisible("password")}
                  alt="visible-password"
                />
                <div style={{ height: "20px" }}>
                  <TextError>
                    {this.state["SIGNUP"]._error !== null
                      ? this.state["SIGNUP"]._error.errors.password !==
                        undefined
                        ? this.state["SIGNUP"]._error.errors.password[0]
                        : null
                      : null}
                  </TextError>
                </div>
              </div>
            </FormGroup>

            <FormGroup style={{ margin: "70px 0px" }}>
              <Label for="confirm_password">Password Confirmation</Label>
              <div style={{ position: "absolute", width: "92%" }}>
                <Input
                  type={visibleConfirmPassword ? "text" : "password"}
                  name="confirm_password"
                  id="confirm_password"
                  onChange={this.onChange}
                />
                <KickImage
                  className={classNames("img-eye confirm")}
                  src={visibleConfirmPassword ? eyeOpen : eyeClose}
                  onClick={() => this.toggleVisible("confirm")}
                  alt="visible-password"
                />
                <div style={{ height: "20px" }}>
                  <TextError>
                    {this.state["SIGNUP"]._error !== null
                      ? this.state["SIGNUP"]._error.errors.confirm_password !==
                        undefined
                        ? this.state["SIGNUP"]._error.errors.confirm_password[0]
                        : null
                      : null}
                  </TextError>
                </div>
              </div>
            </FormGroup>

            <FormGroup>
              <Label>Country</Label>
              <InputSelect
                name="countrySelected"
                className={classNames("input-select", {
                  "is-invalid": this._hasError("countrySelected")
                })}
                value={this.state.countrySelected}
                onChange={this.handleSelectCountryChange}
                options={this.state.countryList}
              />
            </FormGroup>

            <FormGroup>
              <Label>Province</Label>
              <InputSelect
                name="provinceSelected"
                className={classNames("input-select", {
                  "is-invalid": this._hasError("provinceSelected")
                })}
                value={this.state.provinceSelected}
                onChange={this.handleSelectProvinceChange}
                options={this.state.provinceList}
              />
            </FormGroup>
            <div style={{ marginTop: 34, textAlign: "right" }}>
              <p>Already have an account?</p>
              You can{" "}
              <span
                className="text-black green-link d-inline-block cursor-pointer"
                onClick={() => this._toggleLogin("LOGIN")}
              >
                click here to <b>LOGIN</b>
              </span>
            </div>

            <ButtonSubmit
              className="btn-green bold mt20"
              size="lg"
              buttonText="Register"
              disabled={this.state._submitSignUp === true}
              block
              social={this.state._submitSocial}
            />
          </Form>
        </Col>
      </Row>
    );
  };

  _renderForgetPassword = () => {
    return (
      <Row>
        <Col>
          <div
            className="text-center"
            style={{ marginBottom: 55, marginTop: 10 }}
          >
            <h4>Forgot Password</h4>
            <p>
              Please enter your email address below. you will receive a link to
              reset your password.
            </p>
          </div>

          <AlertSuccess
            status_code={this.props.dataReset.data.status_code}
            message={this.props.dataReset.data.message}
            onBack={() => this._toggleLogin("LOGIN")}
          >
            <div style={{ marginBottom: 15 }}>{this._renderError()}</div>

            <Form onSubmit={this.onForgetPassword}>
              <Label for="email">Email</Label>
              <Input
                autoComplete="off"
                type="email"
                name="email"
                id="email"
                onChange={this.onChange}
                className={classNames("", {
                  "is-invalid": this._hasError("email")
                })}
              />
              <FormFeedback
                errors={
                  this.state["FORGET_PASSWORD"]._error !== null
                    ? this.state["FORGET_PASSWORD"]._error.errors
                    : undefined
                }
                field="email"
              />
            </Form>

            <p className="text-right">
              or{" "}
              <span
                className="text-black green-link d-inline-block cursor-pointer"
                onClick={() => this._toggleLogin("LOGIN")}
              >
                Back to <b>LOGIN</b>
              </span>
            </p>

            <ButtonSubmit
              onClick={this.submitForget}
              className="btn-green bold mt20"
              size="lg"
              buttonText="Submit"
              disabled={this.state._submitForgetPassword === true}
              block
              social={this.state._submitSocial}
            />
          </AlertSuccess>
        </Col>
      </Row>
    );
  };

  _toggleLogin = sections => {
    //e.preventDefault();
    this.setState({
      sections,
      _submitSignin: false,
      _submitSocial: false,
      _submitForgetPassword: false
    });

    if (sections === "FORGET_PASSWORD") {
      this.props.doClearResetPassword();
    }
  };

  onLogin(e) {
    e.preventDefault();
    this.props.doFetchProfile()
    this.setState(prevState => {
      return {
        LOGIN: {
          ...prevState.LOGIN,
          _error: null
        }
      };
    });
    if (Object.keys(this._validateForm()).length === 0) {
      this.setState({ _submitSignin: true }, () => {
        Analytics.recordSignIn("email_and_password", this.state["LOGIN"].email);
        this.props.doSignIn(this.state["LOGIN"]);
      });
    }
  }
  onSignUp(e) {
    e.preventDefault();
    this.setState(prevState => {
      return {
        SIGNUP: {
          ...prevState.SIGNUP,
          seller_location_id:
            this.state.provinceSelected && this.state.provinceSelected.value,
          _error: null
        }
      };
    });

    if (!Object.keys(this._validateForm()).length) {
      this.setState({ _submitSignUp: true }, () => {
        Analytics.recordSignUp(
          "email_and_password",
          this.state["SIGNUP"].email
        );
        this.props.doSignUp(this.state["SIGNUP"]);
      });
    }
  }
  onForgetPassword(e) {
    e.preventDefault();
    this.setState(prevState => {
      return {
        FORGET_PASSWORD: {
          ...prevState.FORGET_PASSWORD,
          _error: null
        }
      };
    });
    if (!Object.keys(this._validateForm()).length) {
      this.setState({ _submitForgetPassword: true }, () => {
        const { email } = this.state["FORGET_PASSWORD"];
        this.props.doForgetPassword({ email });
      });
    }
  }

  submitForget() {
    this.setState(prevState => {
      return {
        FORGET_PASSWORD: {
          ...prevState.FORGET_PASSWORD,
          _error: null
        }
      };
    });
    if (!Object.keys(this._validateForm()).length) {
      this.setState({ _submitForgetPassword: true }, () => {
        const { email } = this.state["FORGET_PASSWORD"];
        this.props.doForgetPassword({ email });
      });
    }
  }

  isFromWebApps = () => {
    let localValue = localStorage.getItem(IS_FROM_WEB_APPS);
    return this.props.isWebApp || localValue === "true";
  };

  _renderLoginWithSocmed = () => {
    return (
      <Row className="auth-social">
        <p style={{ width: "100%", textAlign: "center" }}>
          {this.state.sections} WITH
        </p>
        <Col xs={6} sm={6} md={6} lg={6}>
          <div
            className={classNames("col-auth-fb", {
              disabled: this.state._submitSocial || this.state._submitSignin
            })}
          >
            <FacebookLogin
              appId="1588115344582034"
              fields="name,email,verified"
              version="2.12"
              disableMobileRedirect={true}
              scope="public_profile,email"
              onFailure={this._failureFacebook}
              callback={this._responseFacebook}
              isDisabled={this.state._submitSocial || this.state._submitSignin}
              render={props => (
                <div className="auth-facebook" onClick={props.onClick}>
                  <span className="text-auth-facebook">FACEBOOK</span>
                </div>
              )}
            />
          </div>
        </Col>

        <Col xs={6}>
          <div className="col-auth-google">
            <GoogleLogin
              clientId="594858415021-kion5vibkgo9kf91toajjcb6h7ltt4aq.apps.googleusercontent.com"
              onSuccess={this._responseGoogle}
              onFailure={this._responseGoogle}
              className="auth-google"
              disabled={this.state._submitSocial || this.state._submitSignin}
              disabledStyle={{ opacity: 0.65 }}
            >
              <span className="text-auth-google">GOOGLE+</span>
            </GoogleLogin>
          </div>
        </Col>
      </Row>
    );
  };

  render() {
    return (
      <Modal
        isOpen={this.props.isOpen}
        toggle={this._toggle}
        size="lg"
        className="kick-modal full"
        id="modal-login-register"
        backdropClassName="white-backdrop"
        style={{
          padding: 20,
          border: "1px solid #ccc",
          backgroundColor: "#fff"
        }}
      >
        <ModalHeader toggle={this._toggle}>
          <KickAvenueBrandIcon
            src="/images/app-icon.png"
            className="kickavenue"
            alt="kickavenue"
          />
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col xs="12" md="6" className="borderRight">
              <div>
                <KickImage src="/images/shoe-cartoon.png" width="100%" />
              </div>
            </Col>
            <Col xs="12" md="6">
              <Form>
                {this.state.sections !== "FORGET_PASSWORD" &&
                  this._renderLoginWithSocmed()}
                {this.state.sections === "LOGIN" && this._renderLogin()}
                {this.state.sections === "SIGNUP" && this._renderSignUp()}
                {this.state.sections === "FORGET_PASSWORD" &&
                  this._renderForgetPassword()}
              </Form>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    );
  }
}
const AlertSuccess = ({ status_code, message, children, onBack }) => {
  return status_code === 200 ? (
    <Alert className="no-border-radius" color="success">
      <h4 className="alert-heading">Well done!</h4>
      <p>{`${message}`}</p>
      <hr />
      <p className="text-right">
        or{" "}
        <span
          className="text-black green-link d-inline-block cursor-pointer"
          onClick={onBack}
        >
          Back to <b>LOGIN</b>
        </span>
      </p>
    </Alert>
  ) : (
      children
    );
};

const TextError = styled.span`
  font-size: 0.65rem;
  color: #dc3545;
  height: 20px;
`;

//const mapStateToProps = state =>({
const mapStateToProps = ({
  dataResetPassword,
  loginReferralReducer,
  dataAuth: { signIn, signUp, isLogged, shouldRedirect },
  dataPostalCode: { countries, provinces }
}) => ({
  dataSignIn: signIn,
  dataSignUp: signUp,
  dataAuth: { isLogged, shouldRedirect },
  dataReset: dataResetPassword,
  isLogged,
  isWebApp: loginReferralReducer.loginReferral.isWebApp,
  dataCountries: countries,
  dataProvinces: provinces
});
const mapDispatchToProps = dispatch => ({
  doSignIn: user => dispatch(doSignIn(user)),
  doSocialSignIn: user => dispatch(doSocialSignIn(user)),
  login: ({ email, password }) => dispatch(doSignIn({ email, password })),
  doSignUp: ({ email, password }) => dispatch(doSignUp({ email, password })),
  doClearResetPassword: () => dispatch(doClearResetPassword()),
  doForgetPassword: payload => dispatch(doRequestResetPassword(payload)),
  getCountries: () => dispatch(doFetchCountries()),
  getProvinces: country => dispatch(doFetchProvinces(country)),
  doFetchProfile: () => dispatch(doFetchProfile())
});
export default connect(mapStateToProps, mapDispatchToProps)(ModalLoginNew);
